module.exports = __webpack_public_path__ + "static/media/main_1.61718fc2.png";